import GoogleAnalytics from "./ga";
import YaCounter from "./ym";

let ym = new YaCounter();
$(document).on('click', '[data-yagoal]', function () {
	ym.goal($(this).data('yagoal'));
});
$(document).on('submit-success', 'form[data-form-yagoal]', function () {
	ym.goal($(this).data('form-yagoal'));
});

let ga = new GoogleAnalytics();
$(document).on('click', '[data-gagoal]', function () {
	ga.goal($(this).data('gagoal'));
});
$(document).on('submit-success', 'form[data-form-gagoal]', function () {
	ga.goal($(this).data('form-gagoal'));
});

// calltouch
setTimeout(() => {
	let calltouch_session = null;

	try {
		calltouch_session = window.ct('calltracking_params', App.ct.mid).sessionId;
	} catch (e) {
		// console.log(e)
	}

	if (calltouch_session) {
		$('form[data-vgformsender]').each(function (i, form) {
			$(form).append(`<input type="hidden" name="calltouch_session" value="${calltouch_session}"/>`);
		});
	}
}, 3000);
